var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSinglehuman(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.351,
    height: 25.351,
    viewBox: "0 0 25.351 25.351",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_182",
    "data-name": "Trac\\xE9 182",
    d: "M14.675,14.675A6.338,6.338,0,1,0,8.338,8.338,6.338,6.338,0,0,0,14.675,14.675ZM18.9,8.338a4.225,4.225,0,1,1-4.225-4.225A4.225,4.225,0,0,1,18.9,8.338Zm8.45,16.9a2.069,2.069,0,0,1-2.113,2.113H4.113A2.069,2.069,0,0,1,2,25.238c0-2.113,2.113-8.45,12.675-8.45S27.351,23.125,27.351,25.238Zm-2.113-.008a5.644,5.644,0,0,0-1.758-3.515C22.1,20.337,19.511,18.9,14.675,18.9S7.248,20.337,5.87,21.714A5.656,5.656,0,0,0,4.113,25.23Z",
    transform: "translate(-2 -2)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSinglehuman);
export default __webpack_public_path__ + "static/media/icon-singlehuman.6a3f73f7a20f458547655875c03ceccf.svg";
export { ForwardRef as ReactComponent };